import { render, staticRenderFns } from "./CustomerUserShowDetailsTab.vue?vue&type=template&id=2a29a3fa"
import script from "./CustomerUserShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerUserShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports